import moment from 'moment';
import Tolls from '../../../services/toll';

export default{
  data() {
    return {
      dataTransfer:undefined,
      loading: undefined,
      summaryVP: {}
    }
  },
  computed: {
    getDateTransfer() {
      return moment().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]')
    },
    contractId: function(){
      
      return this.$route.params.contractId;
    },
    idVP: function(){
      
      return this.$route.params.idVP;
    },
  },

  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  },
  mounted(){
      $('[data-toggle="tooltip"]').tooltip();

      this.dataTransfer = this.$route.params.dataTransfer;

      return this.loading = Tolls.getById(this.idVP).then(resp => {
        this.summaryVP = resp;
        
        // this.rate = resp.taxTotal;
        // this.credit = resp.valueTotal + resp.taxTotal;
      }).catch(err => {
        
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/toll-ticket/receipt.js